import { createSlice } from '@reduxjs/toolkit';
import { getJSONFromHtml } from '../../../../../domain/common';
import { IQPlayerData, IQPlayerDataItem } from '../../interfaces';
import { formatData } from '../../domain/player-provider';

interface IState{
    data: IQPlayerData|null;
    selected: IQPlayerDataItem|null;

    isLoading: boolean;
    isPlaying: boolean;
    isBypass: boolean;
    isDelta: boolean;

    audioContext: AudioContext;
}

const data = formatData(getJSONFromHtml(document.getElementById('iq-player-json')) as IQPlayerData|null);
const audioContext = new AudioContext();

const initialState: IState = {
    data,
    selected: null,

    isLoading: true,
    isPlaying: false,
    isBypass: false,
    isDelta: false,

    audioContext,
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;